import { render, staticRenderFns } from "./OverdueNotice2.vue?vue&type=template&id=154320e4&scoped=true&"
import script from "./OverdueNotice2.vue?vue&type=script&lang=js&"
export * from "./OverdueNotice2.vue?vue&type=script&lang=js&"
import style0 from "./OverdueNotice2.vue?vue&type=style&index=0&id=154320e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154320e4",
  null
  
)

export default component.exports